import { SelectableStudentLists, StudentSelection } from '../models/Assignment';

/**
 * Whether the teacher narrowed the student list or ran with it as the sidebar built it. Students
 * arrive pre-selected, so a single unchecked student anywhere means the list was curated. Note
 * that the "Do Not Include" shortcut also unchecks students, and counts as narrowing.
 */
export const getStudentSelection = (studentsLists: SelectableStudentLists): StudentSelection =>
  [studentsLists.readyToLearn, studentsLists.buildingFoundations, studentsLists.alreadyMastered].every(({ list }) =>
    list.every(student => student.selected),
  )
    ? 'left_default'
    : 'narrowed';
